module.exports = __webpack_public_path__ + "static/media/0227_Medium.587b5b23.jpg";